import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.BRANCH = function (state, payload) {
  state.branch = payload
}
mutations.SAVEINSTRUCTOR = function (state, payload) {
  if (Array.isArray(payload)) {
    state.row = null
    state.rows = payload
  } else {
    state.error = true
    state.showError = payload
  }
}

const state = {
  rows: [],
  row: null,
  branch: [],
  error: false,
  showError: null,
  condition: {}
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        branch: {api: 'M0101BranchService.findBranchForListBox'}
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('BRANCH', data.branch.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0601Instructor cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0601Instructor search')
    return client.postData({ data: { search: { api: 'M0601InstructorService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0601Instructor add')
    commit('EDIT',
      {
        id: null,
        user: [{username: '', password: ''}],
        birthday: '',
        instructor_name: '',
        instructor_number: ''
        /* files: {},
        relates: {},
        belongs: {} */
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0601Instructor edit')
    return client.postData({ data: { find: { api: 'M0601InstructorService.getDataDetails', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0601Instructor delete')
    return client.postData({ data: { delete: { api: 'M0601InstructorService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0601Instructor save')
    return client.postData({ data: { save: { api: 'M0601InstructorService.saveDataDetails', input: row } } })
      .then((data) => {
        commit('SAVEINSTRUCTOR', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0601Instructor download')
    return client.download({ data: { download: { api: 'M0601InstructorService.downloadData', input: condition } } })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0601Instructor/M0601InstructorStore.js